import pactometer from '../modules/pactometer';

function init() {
  if (document.querySelector('[data-controller*="ac-pactometer"]')) {
    window.dataManager.getGenerales().then((generales) => {
      if (generales) {
        pactometer.init(generales);
      }
    });
  }
}

export default init;
